const singleItemBundle = () => {
  const boxAddBtn = document.querySelector(
    '.single-product.is-part-of-bundle .single_add_to_cart_button_variable'
  );

  if (boxAddBtn) {
    boxAddBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
    });
  }

  const singleBundleForm = document.querySelector(
    '.single-product.is-part-of-bundle form.cart'
  );

  // Check for WooCommerce notice
  const Notice = document.querySelector('.woocommerce-notices-wrapper');

  if (Notice.innerHTML !== '') {
    const pos = Notice.getBoundingClientRect().top + window.pageYOffset - 125;

    // Scroll to notice
    window.scrollTo({ top: pos, behavior: 'smooth' });
  }

  if (singleBundleForm) {
    singleBundleForm.addEventListener(
      'submit',
      function (e) {
        // Eww jQuery.
        // Block the page while we wait for a reponse from the backend.
        $('body.single-product').block({
          message: null,
          overlayCSS: {
            background: '#fff',
            opacity: 0.8
          }
        });

        e.preventDefault();
        const quanity = document.querySelector('input[name=quantity]').value;
        const product_id = singleBundleForm.dataset.product_id;
        const attribute_slug = document.getElementById('pa_quantity');
        const variation_id = document.querySelector('input[name=variation_id]')
          .value;

        fetch(tofinoJS.ajaxUrl, {
          method: 'post',
          body: new URLSearchParams({
            action: 'add-bundle-item',
            // security: this.security, @TODO: Fix this so it works
            data: JSON.stringify({
              product_id: parseInt(product_id),
              quanity: parseInt(quanity),
              bundle_product_id: parseInt(
                thefinercookieJS.custom_box_product_id
              ),
              variation_id: parseInt(variation_id),
              attribute_slug: attribute_slug.value
            })
          })
        })
          .then(async (response) => {
            const data = await response.json();
            $('body.single-product').unblock();

            if (data.success) {
              location.reload();
            } else {
              alert('Something went wrong. Unable to add item to Gift Box.');
            }
          })
          .catch((error) => {
            console.error(error);

            alert('A system error has occured. Please try again later.');
          });
      },
      true
    );
  }
};

export default singleItemBundle;
